module.exports = __webpack_public_path__ + "img/svg/multiplayer-competition-card.a2bc3f4f828fc9ca7bc87f923da00625.svg";